import { formatValue } from 'react-currency-input-field';

/**
 * Check is value is null, undefined or empty string
  @param {String} s Tester value.
  @returns {boolean} true/false
*/
const IsNotNull = (s) => {
  return s ? true : false
}

/**
 * Check is pattern is matching
  @param {String} v Tester value.
  @param {String} regexp Tester value.
  @returns {boolean} true/false
*/
const patternCheck = (v, regexp) => {
  return regexp.test(v);
}

const str2ab = (str) => {
  let buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
  let bufView = new Uint16Array(buf);
  for (var i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}


/*
  value: this
  has_dec: has decimal
  dec: max decimal
*/
const toFloat = (value, has_dec, dec) => {
  let tmp_val = IsNotNull(value) ? value : 0
  let rs = 0
  rs = parseFloat(has_dec ? parseFloat(tmp_val.toString().replace(/,/g, '.')).toFixed(dec) : tmp_val.toString().replace(/,/g, '.'))
  return rs
}

/*
for check isnotnull or return default
  value: check value
  def: default value
*/
const INNRD = (value, def) => {
  return IsNotNull(value) ? value : def
}

/*
for check isnotnull for select option value return default
  opt: check option
  def: default value
*/
const INNSD = (opt, def) => {
  return IsNotNull(opt.value) ? opt : def
}

const FindOption = (find_value, st_opt) => {
  return IsNotNull(find_value) && IsNotNull(st_opt) ? st_opt.options.find(option => option.value === find_value) : ''
}

/**
 * Mapping options 
  @param {root} troot this.
  @param {Array} data options array from db.
  @param {String} data placeholder.

  @param {State} st_opt state options.
  @param {String} f1 db col id.
  @param {String} f2 db col name.
  @param {boolean} cmb combine t/f.
  @param {String} c1 db col.
  @param {String} c2 db col.

  @returns {String} Formatted String Number
*/
const MappingOptions = async (setter, data, ph, f1, f2, cmb, c1, c2) => {
  if (IsNotNull(data)) {
    let g = [{ label: 'None', value: null, o: null }];
    data.map(x => ( g.push({ label: IsNotNull(cmb) ? cmb ? `${x[c1]} - ${x[c2]}` : x[f2] : x[f2], value: x[f1], o: x }) ))
    const options = [{ label: ph, options: g }]
    // await troot.setState({ [st_opt]: options })
    await setter(options)
  }
}

/**
 * Get Formatted Number
  @param {String} num value.
  @param {String} group grouping symbol.
  @param {String} decimal decimal symbol.
  @returns {String} Formatted String Number
*/
const getFormattedNumber = (num, group, decimal) => {
  let rs = formatValue({
    value: num.toString(),
    groupSeparator: group,
    decimalSeparator: decimal
  });
  return rs;
}


export {
  IsNotNull,
  patternCheck,
  str2ab,
  toFloat,
  INNRD,
  INNSD,
  MappingOptions,
  FindOption,
  getFormattedNumber
}